<div id="firstDiv" tabindex="1"></div>
<a id="skip-link" role="button" class="btn btn-primary skip-link" tabindex="2" href (keydown)="skipNavigation($event)"
   (click)="skipNavigation($event)" aria-label="Skip to Main Content">Skip to Main Content</a>



<nav id="mainNavbar" class="navbar navbar-expand-md bg-primary fixed-top navbar-main  navbar-inverse" aria-label="Main Navigation Menu">

  <div class="container-fluid d-flex justify-content-end">

    <!--Hamburger menu-->
    <button id="navbar-toggler" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar" (click)="navbarButtonClicked()">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Links -->
    <div class="collapse navbar-collapse" id="collapsibleNavbar" role="navigation">
      <ul class="navbar-nav" id="mainUL">
        <li class="nav-item" (click)="navbarLinkClicked()">
          <a href="javascript:void(0);" class="navbar-brand product-name text-white nav-link"
             (click)="init('home'); navigateTo('/')" aria-label="Reed Tech SingleSource"
             [ngClass]="isRouteActive('/home')" role="button">
            <img src="../../../../assets/images/LN-Orb-KO.svg" alt="Reed Tech" class="navbar-globe">
            <span class="navbar-brand-name">
              Reed Tech SingleSource&trade;
            </span>
          </a>
        </li>
        <li class="nav-item" (click)="navbarLinkClicked()" *ngIf='loggedIn && permissionsSet'>
          <a class="nav-link text-white" *ngIf="loggedIn" href="javascript:void(0);"
             (click)="init('/files/fileupload'); navigateTo('/files/fileupload')" aria-label="Upload File"
             [ngClass]="isRouteActive('/files/fileupload')" role="button" tabindex="0">Upload File</a>
        </li>
        <li class="nav-item" (click)="navbarLinkClicked()" *ngIf='loggedIn && permissionsSet'>
          <a class="nav-link text-white" *ngIf="loggedIn" href="javascript:void(0);"
             (click)="init('/managedi/inventory'); navigateTo('/managedi/inventory')" aria-label="Manage DI"
             [ngClass]="isRouteActive('/managedi/inventory')" role="button" tabindex="0">Manage DI</a>
        </li>
        <li class="nav-item dropdown" *ngIf='loggedIn && permissionsSet'>
          <a class="nav-link dropdown-toggle text-white focused-no-tabindex" href="#" role="button"
             data-bs-toggle="dropdown">Manage Submissions</a>
          <ul class="dropdown-menu bg-primary">
            <li (click)="navbarLinkClicked()">
              <a *ngIf="loggedIn" href="javascript:void(0);" aria-label="Manage Submission Items"
                 (click)="init('/submissions/managesubmissionitems'); navigateTo('/submissions/managesubmissionitems')"
                 [ngClass]="isRouteActive('/submissions/managesubmissionitems')" role="button" tabindex="0"
                 class="dropdown-item text-white">Manage Submission Items</a>
            </li>
            <li (click)="navbarLinkClicked()" *ngIf='loggedIn && permissionsSet'>
              <a *ngIf="loggedIn" href="javascript:void(0);" aria-label="Submission History"
                 (click)="init('/submissions/submissionhistory'); navigateTo('/submissions/submissionhistory')"
                 [ngClass]="isRouteActive('/submissions/submissionhistory')" role="button" tabindex="0"
                 class="dropdown-item text-white">Submission History</a>
            </li>
          </ul>
        </li>
        <li class="nav-item" (click)="navbarLinkClicked()" *ngIf='loggedIn && permissionsSet'>
          <a class="nav-link text-white" *ngIf="loggedIn && exportDataPermitted" href="javascript:void(0);"
             (click)="init('exportdata'); navigateTo('/reports/exportdata')"
             [ngClass]="isRouteActive('/reports/exportdata')" aria-label="Export Data" role="button">Export Data</a>
        </li>
        <li class="nav-item" (click)="navbarLinkClicked()" *ngIf='loggedIn && permissionsSet'>
          <a class="nav-link text-white" *ngIf="loggedIn" href="javascript:void(0);"
             (click)="init('support'); navigateTo('/support')" aria-label="Support and Feedback"
             [ngClass]="isRouteActive('/support')" role="button">
            Support
          </a>
        </li>
      </ul>
      <ul class="navbar-nav navbar-right">
        <li class="nav-item-hello  flex-grow-1 flex-shrink-1" *ngIf="loggedIn">
          <span href="javascript:void(0);" tabindex="0" aria-label="Greeting area - Hello logged in user"
                class="greeting">
            Hello
            {{userName | splitWords:" ":0 }}
          </span>
        </li>
        <li class="nav-item  flex-grow-1 flex-shrink-1 py-auto px-auto" *ngIf="loggedIn && apiAccessPermitted">
          <a class="nav-link text-white"
             (click)="init('/settings/clientsettings'); navigateTo('/settings/clientsettings')" role="button"
             aria-label="Manage API Credentials" href="javascript:void(0);"
             [ngClass]="isRouteActive('/settings/clientsettings')" role="button"><i class="fal fa-cog fa-lg"></i></a>
        </li>
        <li class="nav-item flex-grow-1 flex-shrink-1 text-center" *ngIf="loggedIn">
          <a class="nav-link text-white" (click)="logout()" role="button" aria-label="Sign Out" tabindex="0">
            <i class="fal fa-sign-out-alt"></i> Sign Out
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>


<nav class="navbar-nav navbar-secondary navbar-expand-sm bg-default" role="navigation"
     aria-label="Secondary navigation">
  <div [hidden]="!userData" class="d-inline-flex px-3 pt-3 ms-5">

    <div class="flex-fill px-2 mx-2" >
      <p class="navbar-text"><span id="current-selection" class="hide-small" aria-label="Current Selection"
              tabindex="0">Current Selection&nbsp;&nbsp;/&nbsp;&nbsp;</span>Company
        <span aria-label="Current Customer" class="navbar-value">{{currentCustomer?.customerName}}</span>
      </p>
    </div>
    <div class="flex-fill px-2 mx-2">
      <p *ngIf="displayDataScope()" class="navbar-text" aria-label="Health Authority" tabindex="0">Health Authority
        <span aria-label="Current Health Authority" class="navbar-value">{{dataScope | uppercase }}</span>
      </p>
    </div>
    <div class="flex-fill px-2 mx-2" *ngIf="displayChangeSelectionLink() && userData && currentCustomer">
      <p class="navbar-text">
        <a href="javascript:void(0)" class="pointer" id="change-selection" tabindex="0"
           (click)="openCompanySelectionModal({open: true, navigateToUrl: ''})" aria-haspopup="true"
           aria-expanded="false" role="button" aria-labelledby="current-selection">Change selection</a>
      </p>
    </div>

  </div>
</nav>

